/** SSO UI switches: only when /auth/config says AUTH_MODE=sso. */

export type AuthModeConfig = {
  auth_mode?: string
  identity_url?: string
  client_id?: string
}

export const SKIP_SSO_AUTO_KEY = 'expenses_skip_sso_auto'

export function shouldUseAccounts(cfg?: AuthModeConfig | null): boolean {
  return (cfg?.auth_mode || '').toLowerCase() === 'sso'
}

export function accountsBaseUrl(identityUrl?: string | null): string {
  const fromCfg = (identityUrl || '').replace(/\/$/, '')
  if (fromCfg) return fromCfg
  if (typeof window !== 'undefined' && window.location.hostname.includes('staging.')) {
    return 'https://staging.accounts.metrica.co.il'
  }
  return 'https://accounts.metrica.co.il'
}

export function accountsTenantsUrl(identityUrl?: string | null): string {
  return `${accountsBaseUrl(identityUrl)}/admin/tenants`
}

export function accountsUsersUrl(identityUrl?: string | null): string {
  return `${accountsBaseUrl(identityUrl)}/admin/users`
}

export function accountsLoginUrl(identityUrl?: string | null): string {
  return `${accountsBaseUrl(identityUrl)}/login`
}

export function accountsLogoutUrl(identityUrl?: string | null): string {
  return `${accountsBaseUrl(identityUrl)}/logout`
}
